import Vue from 'vue';
import VueRouter from 'vue-router';
import cdyRouter from './cdy';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'download',
    meta: {
      title: '草都云',
    },
    component: () => import('@/views/cdy/download/download.vue'),
  },
  // ...cdyRouter,
];

const router = new VueRouter({
  mode: 'history', // process.env.NODE_ENV === 'production' ? 'history':'hash' ,
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

export default router;
